<!--
 * @Descripttion: 
 * @Author: cocoLee
 * @Date: 2022-02-15
 * @LastEditors: yangsibo
 * @LastEditTime: 2023-01-30 15:50:51
-->
<template>
  <div class="layout">
    <el-container direction="vertical" class="my-container">
      <Header></Header>
      <el-container class="container-w" style="">
        <SideBar></SideBar>
        <el-container direction="vertical" class="container-i">
          <router-view />
          <Footer></Footer>
        </el-container>
      </el-container>
    </el-container>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import SideBar from '@/components/SideBar/index'
export default {
  name: 'Home',
  components: {
    Header,
    SideBar,
    Footer,
  },
  watch: {
    $route(to, from) {
      this.getBreadcrumb()
      // 全局拦截是否为当前合作社下或则村集体下，统一添加参数标识
      const paths = ['/village/management/list', '/cooperative/management/list']
      if (
        from.query.$businessType &&
        from.query.$businessType === '_blank' &&
        !paths.includes(to.path)
      ) {
        const {
          $businessId,
          $businessName,
          $businessType,
          $businessAccountId,
          $backPath,
        } = from.query
        const routeResolve = this.$router.resolve({
          path: to.fullPath,
          query: {
            $businessId,
            $businessName,
            $businessType,
            $businessAccountId,
            $backPath,
          },
        })
        this.$router
          .replace({
            path: routeResolve.route.fullPath,
          })
          .catch(() => { })
      }
    },
  },
  methods: {
    getBreadcrumb() {
      if (Object.keys(this.$route.matched[0].meta).length > 0) {
        this.breadList = this.$route.matched
      } else {
        this.breadList = []
      }
    },
  },
}
</script>
<style lang="scss">
.layout {
  height: 100%;

  .el-container {
    height: calc(100vh - 4.7vw);
    background-color: #f7f8fa;

    &.my-container {
      height: 100vh;
    }

    .el-header {
      padding: 0;
    }

    .el-main {
      display: flex;
      flex-direction: column;
      padding: 0;

      .top-wrap {
        padding: 0 16px;
        background-color: #fff;
        box-shadow: 0px 6px 10px 0px rgba(191, 194, 205, 0.3);

        &>div:nth-child(2) {
          padding: 16px 0 0;
          border-top: 1px solid #e9ebee;
        }
      }

      .main {
        flex: 1;
        padding: 10px 16px 16px;
        margin: 16px 16px 0;
        background: #fff;
      }
    }
  }
}

.aside .el-menu .el-submenu .el-submenu__title i {
  font-weight: 400;
}

.aside>.el-menu>.el-menu-item i {
  font-weight: 400;
}
</style>
